module.exports = __webpack_public_path__ + "img/29.c18a0dfe.svg";